<template>
  <v-app class="page page-base">
    <v-app-bar class="header-list pl-6 pr-8 py-3" app fixed elevation="0" color="lightPrimary" height="80">
      <div class="d-flex flex-grow-1 justify-space-between">
        <div class="d-flex align-center">
          <v-icon left style="margin-right:20px" class="icon-bars" onclick="mobileMenu()">fas fa-bars</v-icon>
          <div class="d-flex gp-8">
            <v-btn text class="custom-btn-icon-gray pa-3 icon-tam-20"
                   v-on:click="
                $router.push(
                  '/admin/rent_trakers'
                )
                ">
              <v-icon>$arrowLeftIcon</v-icon>
            </v-btn>
          </div>
          <v-breadcrumbs class="menu-breadcrumbs pa-0 ml-4" :items="breadcrumbs" divider=">">
          </v-breadcrumbs>
        </div>


        <div class="d-flex align-center ">
          <NotificationMenu></NotificationMenu>
        </div>
      </div>
    </v-app-bar>
    <v-main>
      <v-container>
        <v-row>
          <v-col cols="12">
            <h2 class="mb-4">Conversación del tracker #{{ $route.params.rent_traker_id }}</h2>
            <v-card>
              <v-card-text>
                <div v-if="messages.length === 0">
                  <v-alert type="info" dense border="left" color="lighten-4">
                    No existen mensajes para esta conversación.
                  </v-alert>
                </div>
                <v-list v-else dense>
                  <v-list-item
                      v-for="(msg, index) in messages"
                      :key="msg._id"
                      :class="isHost(msg.sender) ? 'host-message' : 'user-message'"
                  >
                    <v-list-item-content>
                      <v-list-item-title>
                        <strong>{{ fullName(msg.sender) }}:</strong><br>
                        {{ msg.content }}
                      </v-list-item-title>
                      <v-list-item-subtitle>
                        {{ formatDateTimeUtc3(msg.createdAt) }}
                      </v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import NotificationMenu from "@/components/Notification/NotificationMenu.vue";
import {mapState} from "vuex";

export default {
  components: {NotificationMenu},
  data() {
    return {
      breadcrumbs: [
        { text: 'Estadías', disabled: false, href: '/admin/rent_trakers' },
        { text: 'Conversación', disabled: true }
      ],
      title: 'Mensajes',
      // messages: [],
      hostId: null,
      newMessage: ''
    };
  },
  created() {
    this.fetchMessages();
  },
  computed: {
    ...mapState({
      messages: (state) => state.Rent_trakers.messages,
    }),
  },
  methods: {
    async fetchMessages() {
      // this.messages = [
      //   { text: 'Hola, ¿cuándo llega el auto?', from_host: false, created_at: '2025-11-10T14:00:00Z' },
      //   { text: 'En 10 minutos.', from_host: true, created_at: '2025-11-10T14:05:00Z' }
      // ];
      const trackerId = this.$route.params.rent_traker_id;
      const rawMessages = await this.$store.dispatch("Rent_trakers/getMessages", trackerId);

      if (rawMessages.length > 0) {
        this.hostId = rawMessages[0].receiver._id;
      }
    },
    isHost(sender) {
      return sender._id === this.hostId;
    },
    fullName(sender) {
      if (!sender._id) return 'Usuario';

      const capitalize = (str) =>
          str
              .split(' ')
              .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
              .join(' ');

      const name = capitalize(sender.name || '');
      const lastName = capitalize(sender.last_name || '');

      return `${name} ${lastName}`.trim();
    },
    formatDateTimeUtc3(dateStr) {
      const date = new Date(dateStr);
      return date.toLocaleString('es-BO', {
        timeZone: 'America/La_Paz',
        hour: '2-digit',
        minute: '2-digit',
        day: '2-digit',
        month: 'short',
        year: 'numeric'
      });
    }
  }
};
</script>

<style scoped>
.host-message {
  background-color: #f0f4ff;
  border-radius: 8px;
  margin-bottom: 8px;
  padding: 8px;
  align-self: flex-start;
  text-align: left;
}
.user-message {
  background-color: #e8f5e9;
  border-radius: 8px;
  margin-bottom: 8px;
  padding: 8px;
  align-self: flex-end;
  text-align: right;
}
</style>
